import { useMemo } from 'react';

import camelcaseKeys from 'camelcase-keys';
import { parse } from 'query-string';
import { useLocation } from '@reach/router';

type Params = {
  convertToCamelcase?: boolean;
};

export const useQueryString = <T>(params: Params): T => {
  const { search } = useLocation();

  const queries = useMemo(() => {
    const parsedSearch = parse(search, { parseBooleans: true });

    if (parsedSearch && params?.convertToCamelcase) {
      return camelcaseKeys(parsedSearch, { deep: true });
    }

    return parsedSearch;
  }, [params?.convertToCamelcase, search]);

  return queries as unknown as T;
};
